/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const COMPUTE_FIELD_KEYS = {
  architecture: 'system.architecture',
  cpu: 'compute.cpu',
  memory: 'compute.memory',
  gpu: 'compute.gpu',
  bandwidth: 'compute.bandwidth',
} as const;

export const COMPUTE_FIELD_KEY_LIST = [
  COMPUTE_FIELD_KEYS.architecture,
  COMPUTE_FIELD_KEYS.cpu,
  COMPUTE_FIELD_KEYS.memory,
  COMPUTE_FIELD_KEYS.gpu,
  COMPUTE_FIELD_KEYS.bandwidth,
] as const;

export const COMPUTE_ACTION_KEYS = {
  gpuAdd: 'gpu.add',
  gpuRemove: 'gpu.remove',
  pricingSelect: 'pricing.select',
  /** 自定义下单有预置时保留编辑（补数量），隐藏删除 */
  edit: 'compute.edit',
  remove: 'compute.remove',
} as const;

export const COMPUTE_ACTION_KEY_LIST = Object.values(COMPUTE_ACTION_KEYS);
